function escapeHtml(value) {
  return String(value == null ? '' : value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function formatThresholdMoney(cents) {
  return (Math.max(0, cents) / 100).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD'
  });
}

function formatRemaining(baseType, remaining) {
  if (baseType === 'item') {
    return remaining === 1 ? '1 item' : remaining + ' items';
  }
  return formatThresholdMoney(remaining);
}

function cartValueFor(threshold, cart) {
  return threshold.baseType === 'item' ? cart.item_count : cart.total_price;
}

function renderFreeGiftLabel(product, label) {
  if (product && label) {
    return `<a class="card__label" href="${escapeHtml(product.url || '#')}">${escapeHtml(label)}</a>`;
  }
  return `<span class="card__label">${escapeHtml(label || '')}</span>`;
}

function barColors(threshold) {
  return {
    background: escapeHtml((threshold && threshold.barBackgroundColor) || '#d7d7d7'),
    fill: escapeHtml((threshold && threshold.barColor) || '#343333')
  };
}

function thresholdImg(src, options) {
  const className = options && options.className ? options.className : '';
  const alt = options && options.alt ? options.alt : '';
  if (!src) return '';
  return `<img${className ? ` class="${className}"` : ''} src="${escapeHtml(src)}" alt="${escapeHtml(alt)}" loading="lazy">`;
}

const THRESHOLD_CHECK_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none"><line x1="0.940993" y1="3.72005" x2="3.06231" y2="5.84137" stroke="white" stroke-linecap="round"/><line x1="3.06201" y1="5.84107" x2="7.06895" y2="1.83413" stroke="white" stroke-linecap="round"/></svg>';

function enableThresholdHorizontalScroll(element) {
  if (!element || element.dataset.dragScrollBound === 'true') return;

  element.dataset.dragScrollBound = 'true';
  let dragging = false;
  let startX = 0;
  let startScroll = 0;

  element.addEventListener('mousedown', (event) => {
    dragging = true;
    element.classList.add('is-dragging');
    startX = event.pageX - element.offsetLeft;
    startScroll = element.scrollLeft;
  });

  element.addEventListener('mouseleave', () => {
    dragging = false;
    element.classList.remove('is-dragging');
  });

  element.addEventListener('mouseup', () => {
    dragging = false;
    element.classList.remove('is-dragging');
  });

  element.addEventListener('mousemove', (event) => {
    if (!dragging) return;
    event.preventDefault();
    const x = event.pageX - element.offsetLeft;
    element.scrollLeft = startScroll - (x - startX);
  });

  element.addEventListener('wheel', (event) => {
    if (Math.abs(event.deltaY) <= Math.abs(event.deltaX) || element.scrollWidth <= element.clientWidth) return;
    event.preventDefault();
    element.scrollLeft += event.deltaY;
  }, { passive: false });
}

function freeGiftRewardLink(threshold, label) {
  const product = threshold && threshold.freeProduct;
  const text = label || (product && product.title) || '';
  if (!threshold || threshold.rewardType !== 'free_gift' || !product || !text) return '';
  const image = thresholdImg(product.image, { className: 'cart-threshold__product-img' });
  return `<a class="cart-threshold__product-link" href="${escapeHtml(product.url || '#')}">${image}<span>${escapeHtml(text)}</span></a>`;
}

function freeGiftStatus(threshold, remaining, fulfilled) {
  const giftLink = freeGiftRewardLink(
    threshold,
    (threshold.freeProduct && threshold.freeProduct.title) || threshold.rewardCopy
  );
  if (!giftLink) return '';
  if (fulfilled) return `You get <strong>free</strong> ${giftLink}`;
  return `You are ${escapeHtml(formatRemaining(threshold.baseType, remaining))} away from <strong>free</strong> ${giftLink}`;
}

function awayFromMessage(threshold, remaining) {
  const remainingCopy = escapeHtml(formatRemaining(threshold.baseType, remaining));
  return `You are ${remainingCopy} away from <strong>${escapeHtml(threshold.rewardCopy)}</strong>`;
}

function shortRemainingMessage(threshold, remaining) {
  if (threshold.baseType === 'item') {
    return `Add <strong>${remaining}</strong> more ` + (remaining === 1 ? 'item' : 'items');
  }
  return `Add <strong>${escapeHtml(formatThresholdMoney(remaining))}</strong> more`;
}

function renderSingleThreshold(threshold, cart, separate) {
  const value = cartValueFor(threshold, cart);
  const fulfilled = value >= threshold.threshold;
  const percent = threshold.threshold > 0
    ? Math.min(100, Math.max(0, Math.round((value / threshold.threshold) * 100)))
    : 0;
  const remaining = threshold.threshold - value;
  const giftStatus = freeGiftStatus(threshold, remaining, fulfilled);
  const status = giftStatus
    ? giftStatus
    : fulfilled
      ? `You get <strong>${escapeHtml(threshold.rewardCopy)}</strong>` + (separate ? '!' : '')
      : separate
        ? shortRemainingMessage(threshold, remaining)
        : awayFromMessage(threshold, remaining);
  const colors = barColors(threshold);
  const check = fulfilled
    ? `<span class="cart-threshold__bar-check" style="background: ${colors.fill};">${THRESHOLD_CHECK_SVG}</span>`
    : '';

  return `
    <div class="cart-thresholds-combined cart-thresholds-single">
      <p class="cart-threshold__status">${status}</p>
      <div class="cart-threshold__bar-wrapper" style="background: ${colors.background};">
        <div class="cart-threshold__bar" style="width: ${percent}%; background: ${colors.fill};"></div>
        ${check}
      </div>
    </div>`;
}

function renderCombinedThresholds(thresholds, cart) {
  const baseType = thresholds[0].baseType;
  const value = cartValueFor(thresholds[0], cart);
  const fulfilledThreshold = [...thresholds].reverse().find((threshold) => value >= threshold.threshold);
  const nextThreshold = thresholds.find((threshold) => value < threshold.threshold);
  const allFulfilled = !nextThreshold;
  let percent = 100;

  if (!allFulfilled) {
    const previous = fulfilledThreshold ? fulfilledThreshold.threshold : 0;
    const span = nextThreshold.threshold - previous;
    percent = span > 0 ? Math.min(100, Math.max(0, Math.round(((value - previous) / span) * 100))) : 0;
  }

  const nextIndex = thresholds.findIndex((threshold) => value < threshold.threshold);
  const milestones = thresholds.map((threshold, index) => {
    const fulfilled = value >= threshold.threshold;
    const state = fulfilled ? ' fulfilled' : index === nextIndex ? ' next' : ' upcoming';
    const icon = threshold.rewardIcon ? thresholdImg(threshold.rewardIcon) : '';
    const connector = index < thresholds.length - 1
      ? `<span class="milestone-connector${fulfilled ? ' fulfilled' : ''}"></span>`
      : '';
    const check = fulfilled
      ? `<span class="milestone__check">${THRESHOLD_CHECK_SVG}</span>`
      : '';

    return `
      <div class="milestone${state}">
        ${check}
        ${icon}
        <span>${escapeHtml(threshold.rewardCopy)}</span>
      </div>
      ` + connector;
  }).join('');

  let status;
  if (baseType === 'item' && !allFulfilled) {
    status = freeGiftStatus(nextThreshold, nextThreshold.threshold - value, false)
      || awayFromMessage(nextThreshold, nextThreshold.threshold - value);
  } else if (allFulfilled) {
    status = 'You get ' + thresholds.map((threshold) => {
      if (baseType !== 'item') return `<strong>${escapeHtml(threshold.rewardCopy)}</strong>`;
      const giftLink = freeGiftRewardLink(
        threshold,
        (threshold.freeProduct && threshold.freeProduct.title) || threshold.rewardCopy
      );
      return giftLink
        ? `<strong>free</strong> ${giftLink}`
        : `<strong>${escapeHtml(threshold.rewardCopy)}</strong>`;
    }).join(', ');
  } else {
    status = awayFromMessage(nextThreshold, nextThreshold.threshold - value);
  }
  const colors = barColors(allFulfilled ? thresholds[thresholds.length - 1] : nextThreshold);

  return `
    <div class="cart-thresholds-combined">
      <div class="cart-thresholds-milestones">
        ${milestones}
      </div>
      <p class="cart-threshold__status">${status}</p>
      <div class="cart-threshold__bar-wrapper" style="background: ${colors.background};">
        <div class="cart-threshold__bar" style="width: ${percent}%; background: ${colors.fill};"></div>
      </div>
    </div>`;
}

function renderSeparateThresholds(thresholds, cart) {
  const cards = thresholds.map((threshold) => {
    const value = cartValueFor(threshold, cart);
    const fulfilled = value >= threshold.threshold;
    const percent = threshold.threshold > 0
      ? Math.min(100, Math.max(0, Math.round((value / threshold.threshold) * 100)))
      : 0;
    const remaining = threshold.threshold - value;
    const copy = fulfilled
      ? `You get <strong>${escapeHtml(threshold.rewardCopy)}</strong>!`
      : shortRemainingMessage(threshold, remaining);
    const isFreeGift = threshold.rewardType === 'free_gift' && threshold.freeProduct && threshold.rewardCopy;
    const iconSrc = isFreeGift && threshold.freeProduct.image ? threshold.freeProduct.image : threshold.rewardIcon;
    let icon = iconSrc
      ? `<div class="card__icon${isFreeGift ? ' card__icon--product' : ''}">${thresholdImg(iconSrc)}</div>`
      : '';
    if (icon && isFreeGift && threshold.freeProduct.url) {
      icon = `<a class="card__icon-link" href="${escapeHtml(threshold.freeProduct.url)}">${icon}</a>`;
    }
    const colors = barColors(threshold);
    const check = fulfilled
      ? `<span class="card__bar-check" style="background: ${colors.fill};">${THRESHOLD_CHECK_SVG}</span>`
      : '';
    const label = isFreeGift
      ? renderFreeGiftLabel(threshold.freeProduct, threshold.rewardCopy)
      : `<span class="card__label">${escapeHtml(threshold.rewardCopy)}</span>`;

    return `
      <div class="cart-threshold-card${fulfilled ? ' fulfilled' : ''}">
        <div class="card__header">
          ${icon}
          ${label}
        </div>
        <div class="card__bar-wrapper" style="background: ${colors.background};">
          <div class="card__bar" style="width: ${percent}%; background: ${colors.fill};"></div>
          ${check}
        </div>
        <p class="card__copy">${copy}</p>
      </div>`;
  }).join('');

  return `<div class="cart-threshold-cards${thresholds.length === 2 ? ' cart-threshold-cards--two' : ''}">${cards}</div>`;
}

function renderCartThresholdZone(zone, cart) {
  const thresholds = Array.isArray(window.cartThresholds)
    ? window.cartThresholds.filter((threshold) => threshold && threshold.threshold > 0)
    : [];

  if (!thresholds.length) {
    zone.innerHTML = '';
    return;
  }

  const config = window.cartThresholdConfig || {};
  const mixedBaseTypes = thresholds.some((threshold) => threshold.baseType === 'money')
    && thresholds.some((threshold) => threshold.baseType === 'item');
  const separate = config.separateThreshold || mixedBaseTypes;

  zone.innerHTML = thresholds.length === 1
    ? renderSingleThreshold(thresholds[0], cart, separate)
    : (separate ? renderSeparateThresholds : renderCombinedThresholds)(thresholds, cart);

  enableThresholdHorizontalScroll(zone.querySelector('.cart-threshold-cards'));
  enableThresholdHorizontalScroll(zone.querySelector('.cart-thresholds-milestones'));
}

window.renderCartThresholds = function(cart, root) {
  const zones = root
    ? (root.matches && root.matches('.cart-threshold-zone') ? [root] : root.querySelectorAll('.cart-threshold-zone'))
    : document.querySelectorAll('.cart-threshold-zone');

  if (!zones.length) return;
  zones.forEach((zone) => renderCartThresholdZone(zone, cart));
};
